
import { mapState, mapMutations } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: Boolean,
    item: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      selectedItem: null,
      valid: false
    };
  },
  beforeMount() {
    this.selectedItem = { ...this.item };
  },
  computed: {
    ...mapState("menu", ["menuUploadList"])
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),

    handleSavePrice() {
      const index = this.getMenuUploadItemIndex(
        this.menuUploadList,
        this.item.id
      );

      if (index !== -1) {
        this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
          index: index,
          propName: "price",
          propValue: this.selectedItem.price
        });
      }
      if (
        this.item.package_charge &&
        this.item.package_charge > this.getApplicableMaxCharge(this.item)
      ) {
        this.$emit("update-packaging-charge-dialog");
      } else {
        this.$emit("close-dialog");
      }
    }
  }
};
